export default class CreditCardTransactionDetail {
    // Unique identifier for the transaction detail
    id: number;
    transactionItemId: number;
    chargeDate: Date;
    chargeAmount: number;
    chargedByName: string;    
    chargedById: number;
    description: string;
    statementDescription: string;
    clientNumber: number;
    projectNumber: number;
    billingAccount: string;
    expenseCode: string;
    glAccountNumber: string;
    sectionNumber: number;
    unitNumber: number;
    bcdId?: number;
    budgetCategoryName?: string;
    budgetSubcategoryName?: string;
}



// WEBPACK FOOTER //
// ./src/models/AP/CreditCardTransactionDetail.ts